
<!-- <div *ngIf="auth.isAuthenticated$ | async"> -->

@if (userProfileReady) {
  <div class="main-app" #mainApp>
    <router-outlet></router-outlet>
  </div>
}

@if (loaderService.isLoading | async) {
  <div class="loader-overlay">
    <div class="loader">
      <mat-progress-spinner class="griha-theme-spinner" mode="indeterminate"></mat-progress-spinner>
    </div>
  </div>
}

<app-site-visit-pdf-job-toast />
